import type { HttpClient } from '../http/HttpClient'
import type { CardWidgetConfig } from '@/domain/invoice/CardWidgetConfigRepository'
import type { PaymentIndicatorCount, PaymentIndicatorRepository } from '@/domain/payment/PaymentIndicators'

const CONFIG_URL = 'purchases/payments/card-widgets'
const AGGREGATES_URL = 'purchases/payments/card-aggregates'

interface RawConfig {
  available?: Array<{ key?: string | null }> | null
  active?: string[] | null
}

interface RawAggregates {
  cards?: Record<string, { count?: number | null } | null> | null
}

export class HttpPaymentIndicatorRepository implements PaymentIndicatorRepository {
  constructor(private http: HttpClient) {}

  async getConfig(): Promise<CardWidgetConfig> {
    const payload = await this.http.url(CONFIG_URL).get<RawConfig>()
    return {
      available: (payload.available ?? [])
        .map((w) => w?.key)
        .filter((key): key is string => typeof key === 'string' && key.length > 0),
      active: (payload.active ?? []).filter((key): key is string => typeof key === 'string'),
    }
  }

  async saveActive(widgets: string[]): Promise<void> {
    await this.http.url(CONFIG_URL).body({ widgets }).put<unknown>()
  }

  async getCounts(params: Record<string, string | string[]>): Promise<Record<string, PaymentIndicatorCount>> {
    const payload = await this.http.url(AGGREGATES_URL).params(params).get<RawAggregates>()
    const counts: Record<string, PaymentIndicatorCount> = {}
    for (const [key, card] of Object.entries(payload.cards ?? {})) {
      if (typeof card?.count === 'number') counts[key] = { count: card.count }
    }
    return counts
  }
}
